angular.module('bmsApp.settings')
	.controller('JobAlertsCtrl', function (
		$scope,
		notify,
		JobAlertDataSvc
	) {
		let self = this;
		let handlers = {};
		let form = {};

		angular.extend(self, {
			handlers: handlers,
			loading: true,
			job_alerts: null,
			errors: [],
		});

		angular.extend(form, {
			validatorConfig: {},
			validatorApi: {},
			data: {},
			options: {},
			processing: false
		});

		handlers.init = function () {
			JobAlertDataSvc.read().then(function (response) {
				console.info(response);
				self.loading = false;
				self.job_alerts = response.data.job_alerts;
			});
		};

		handlers.submit = function () {
			JobAlertDataSvc.save({job_alerts: self.job_alerts}).then(function(response) {
				notify({
					message: 'Job alert settings saved'
				});
			}, function(error) {
				$scope.errors = error;
				self.errors = error;
			});
		}

	});